import React, { useEffect, useState } from 'react';
import { getWorldAreas } from '../services/checkoutService';
import { Cascader } from 'antd';
import { PropertySafetyFilled } from '@ant-design/icons';

function AreasSelect(props) {
    const [options, setOptions] = useState([])
    useEffect(() => {
        getAreas().then(res => setOptions(res || []));
    }, []);
    function getAreas(params) {
        return new Promise((resolve, reject) => {
            getWorldAreas(params)
                .then(res => {
                    const temp = [];
                    res?.data?.popularAreas?.forEach((item, index) => {
                        temp.push({
                            ...item,
                            label: item?.name,
                            value: item?.name,
                            isLeaf: !item.hasChildren
                        })
                    })
                    res?.data?.worldAreas?.forEach((item, index) => {
                        if(!res?.data?.popularAreas || !res?.data?.popularAreas.find(pItem => pItem.name === item.name)) {
                            temp.push({
                                ...item,
                                label: item?.name,
                                value: item?.name,
                                isLeaf: !item.hasChildren
                            })
                        }
                    })
                    resolve(temp)
                })
        })
    }
    function loadData(selectedOptions) {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        const code = selectedOptions?.map(item => item?.name)?.join('/')
        getAreas(code).then(res => {
            targetOption.loading = false;
            targetOption.children = res;
            setOptions([...options]);
        })
    }
    return (
        <Cascader
            options={options}
            loadData={loadData}
            changeOnSelect
            style={{ width: 250 }}
            onChange={props.onChange}
            value={props?.areas?.map(item => item?.name)}
        />
    )
}

export default AreasSelect;